import { render } from "./FlexMessageJSONModal.vue?vue&type=template&id=f64240da&scoped=true"
import script from "./FlexMessageJSONModal.vue?vue&type=script&lang=ts"
export * from "./FlexMessageJSONModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-f64240da"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QInput,QSpace});
